<template>
  <section class="partner box">
    <com-h1 title="合作伙伴"></com-h1>
    <div class="container" v-for="(group, key) in partners" :key="`partner-${key}`">
      <h2>
        <img v-if="Number(key)===30" src="./assets/zuan.png">
        <img v-if="Number(key)===40" src="./assets/gold.png">
        <img v-if="Number(key)===50" src="./assets/silver.png">
        <img v-if="Number(key)===60" src="./assets/high.png">
        <img v-if="Number(key)===80" src="./assets/media.png">
        <p> {{key | formatType}} </p>
      </h2>
      <div class="columns is-multiline is-mobile">
        <a :href="partner.link" target="blank" class="column is-one-sixth-tablet is-one-third-mobile" v-for="(partner, index) in group" :key="index">
          <img :src="partner.avatar+'?imageView2/0/w/400'">
        </a>
      </div>
    </div>
    <div class="apply box-button">
      <a href="https://jinshuju.net/f/yvosEU" target="_blank"><c-button>赞助机会</c-button></a>
    </div>
  </section>
</template>

<script>
import ComH1 from '@/components/com-h1'
import CButton from '@/components/com-button'

export default {
  components: {
    ComH1,
    CButton
  },
  props: ['partners'],
  data () {
    return {
    }
  },
  computed: {
    // ...mapState({
    //   sponsorLink: state => state.info.sponsorLink
    // })
  },
  mounted () {
  },
  beforeDestroy () {
  },
  methods: {
  },
  filters: {
    formatType (typeId) {
      if (Number(typeId) === 10) return '主办方'
      if (Number(typeId) === 15) return '战略合作伙伴'
      if (Number(typeId) === 20) return '顶级赞助商'
      if (Number(typeId) === 30) return '钻石赞助商'
      if (Number(typeId) === 40) return '金牌赞助商'
      if (Number(typeId) === 50) return '银牌赞助商'
      if (Number(typeId) === 60) return '高级赞助商'
      if (Number(typeId) === 70) return '战略合作媒体'
      if (Number(typeId) === 80) return '合作媒体'
      return '合作媒体'
    }
  }
}
</script>

<style lang="sass" scoped>
@import "../../style/variable"

.partner
  background-color: #f5f7f8

.container
  margin-bottom: 60px

h2
  color: #898989
  display: flex
  align-items: center
  font-size: 24px
  margin-bottom: 30px
  img
    width: 40px
    vertical-align: middle
    margin-left: 0.3em
    margin-right: 0.3em
  p
    margin-right: 0.3em
  &:before, &:after
    display: inline-block
    content: ''
    border-bottom: 1px solid #898989
    flex-grow: 1

.column img
  width: 100%
  height: 15vw
  +tablet
    height: 85px
</style>
